export function SafeToLowerCase(string) {
    return (string && typeof(string) === 'string' && string.length > 0) ? string.toLowerCase() : '';
}